import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ContentElement, SelectOption } from '@urbannex/storethemes';
import { InputField } from '../../../model';

@Component({
  selector: 'kve-radio-options',
  templateUrl: './radio-options.component.html',
  styleUrls: ['./radio-options.component.scss']
})
export class RadioOptionsComponent implements OnChanges{
  @Input() field:InputField;
  @Input() selectedContent:ContentElement;
  value:any;
  selectOptions:any[];
  selectedOption:SelectOption;
  options:any;
  option;

  @Output() updateField: EventEmitter<any> = new EventEmitter<any>();

  constructor(){}
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["field"]){
      console.log(this.field);
      this.options = this.field.context["options"];
      if(this.field.value != undefined && this.field.value != null){
        this.option = this.options.find(option => option.value == this.field.value);
        console.log(this.option);
      }
    }
  }

  onChange(e){
    console.log(e);
    if(e != this.option){
      this.field.value = e.value;
      console.log(this.field);
      this.updateField.emit(this.field);
    }
  }
  
}
